import { render } from "./InfoIcon.vue?vue&type=template&id=08a166ae&scoped=true&ts=true"
import script from "./InfoIcon.vue?vue&type=script&lang=ts"
export * from "./InfoIcon.vue?vue&type=script&lang=ts"

import "./InfoIcon.vue?vue&type=style&index=0&id=08a166ae&lang=scss&scoped=true"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a166ae"]])

export default __exports__